import type { MailboxInfo } from 'owa-client-types';
import { getIndexerValueForMailboxInfo } from 'owa-client-types';
import store from '../store/store';

export default function getAccountCategoryProps(mailboxInfo: MailboxInfo) {
    const key = getIndexerValueForMailboxInfo(mailboxInfo);
    const categoryProps = store.accountCategoryProps.get(key);
    return categoryProps;
}
